import _ from 'underscore';
import $ from 'jquery';

export default class OfferRequestItemTabs {
  constructor($scope, $rootScope, $timeout, OfferRequestService, OfferRequestItemService, EmailService, UiService) {
    $scope.tabs = [
      {
        title: 'Selections',
        items: []
      },
      {
        title: 'Reservations',
        items: []
      },
      {
        title: 'Order Confirmations',
        order_confirmations: []
      },
      {
        title: 'Orders',
        order_confirmations: []
      }
    ];
    
    $scope.oc_fields = function(field) {
      var oc_fields = ['Basic Com', 'Basic Com %', 'Total Amount', 'Commission Unit', 'Commission Amount'];
      if (oc_fields.indexOf(field)) {
        return true;
      } else {
        return false;
      }
    };

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    function update_data() {
      $scope.tabs[0].items = _.filter($scope.items, function(i) {
        return i.status < 2;
      });
      $scope.tabs[1].items = _.filter($scope.items, function(i) {
        return i.status === 2;
      });
      $scope.tabs[2].order_confirmations = _.filter($scope.order_confirmations, function(c) {
        return c.order_id === null;
      });
      $scope.tabs[3].order_confirmations = _.filter($scope.order_confirmations, function(c) {
        return c.order_id !== null;
      });
    }

    $scope.get_status_title = function(status) {
      return _.findWhere($scope.status_options, {
        id: status
      }).title;
    };

    $scope.$on('update_offer_request_item_tabs', function() {
      update_data();
    });

    $scope.edit_offer_request_item = function(item) {
      $scope.$broadcast('show_offer_request_item_dialog', {
        item: item
      });
    };

    $scope.edit_item = function(item) {
      $scope.$broadcast('show_item_dialog', {
        item: item
      });
    };

    $scope.delete_item = function(item) {
      if (confirm('Are you sure you want to delete this item?')) {
        OfferRequestItemService.delete(item.id).success(function(data) {
          if (data.success) {
            $scope.items.splice(_.indexOf($scope.items, item), 1);
            update_data();
          }
        });
      }
    };

    $scope.add_item = function() {
      $scope.$broadcast('show_offer_request_item_dialog', {
        item: {
          offer_request_id: $scope.offer_request.id,
          status: 0,
          supplier_id: $scope.offer_request.supplier_id
        }
      });
    };

    $scope.check_items = function(tab) {
      _.each($scope.tabs[tab].items, function(i) {
        i.checked = $scope.tabs[tab].checked;
      });
    };

    $scope.delete_items = function(tab) {
      var items = _.where($scope.tabs[tab].items, {
        checked: true
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        if (confirm('Are you sure you want to delete the selected items?')) {
          OfferRequestItemService.mass_delete(_.pluck(items, 'id')).success(function(data) {
            if (data.success) {
              $scope.tabs[tab].checked = false;
              $rootScope.$broadcast('load_items');
            }
          });
        }
      }
    };

    $scope.edit_offer_request_items = function(tab) {
      var items = _.where($scope.tabs[tab].items, {
        checked: true
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.$broadcast('show_offer_request_item_dialog', {
          item: {
            supplier_id: $scope.offer_request.supplier_id
          },
          items: _.pluck(items, 'id')
        });
      }
    };

    $scope.edit_items = function(tab) {
      var items = _.where($scope.tabs[tab].items, {
        checked: true
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.$broadcast('show_item_dialog', {
          item: {
            is_reels: null
          },
          items: _.pluck(items, 'item_id')
        });
      }
    };

    $scope.create_order_confirmation = function() {
      var items = _.where($scope.tabs[1].items, {
        checked: true
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.creating_order_confirmation = true;
        OfferRequestService.create_order_confirmation(window.offer_request.id, _.pluck(items, 'id')).success(function(data) {
          if (data.success) {
            $scope.creating_order_confirmation = false;
            $rootScope.$broadcast('load_items');
          }
        });
      }
    };

    $scope.add_items_to_order_confirmation = function() {
      var items = _.where($scope.tabs[1].items, {
        checked: true
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.adding_items_to_order_confirmation = true;
        var oc_items = _.union(_.pluck(items, 'id'), _.pluck($scope.order_confirmation.items, 'id'));
        OfferRequestService.update_order_confirmation($scope.order_confirmation.id, oc_items).success(function(data) {
          if (data.success) {
            $scope.adding_items_to_order_confirmation = false;
            $rootScope.$broadcast('load_items');
          }
        });
      }
    };

    $scope.remove_item_from_order_confirmation = function(order_confirmation, item) {
      item.removing = true;
      OfferRequestService.remove_order_confirmation_items(order_confirmation.id, [item.id]).success(function(data) {
        if (data.success) {
          item.removing = false;
          $rootScope.$broadcast('load_items');
        }
      });
    };

    $scope.remove_items_from_order_confirmation = function(order_confirmation) {
      order_confirmation.mass_removing_items = true;
      window.items = _.pluck(_.where(order_confirmation.items, {
        checked: true
      }), 'id');
      OfferRequestService.remove_order_confirmation_items(order_confirmation.id, window.items).success(function(data) {
        if (data.success) {
          order_confirmation.mass_removing_items = false;
          $rootScope.$broadcast('load_items');
        }
      });
    };

    $scope.create_order_confirmation_docs = function(order_confirmation) {
      order_confirmation.creating_order_confirmation_docs = true;
      OfferRequestService.create_order_confirmation_docs(order_confirmation.id).success(function(data) {
        if (data.success) {
          order_confirmation.creating_order_confirmation_docs = false;
          $rootScope.$broadcast('load_items');
        }
      });
    };
    
    $scope.create_order_confirmation_docs_with_sc_id = function(order_confirmation) {
      order_confirmation.creating_order_confirmation_docs_with_sc_id = true;
      OfferRequestService.create_order_confirmation_docs(order_confirmation.id,true).success(function(data) {
        if (data.success) {
          order_confirmation.creating_order_confirmation_docs_with_sc_id = false;
          $rootScope.$broadcast('load_items');
        }
      });
    };

    $scope.create_order = function(order_confirmation) {
      order_confirmation.creating_order = true;
      OfferRequestService.create_order(order_confirmation.id).success(function(data) {
        if (data.success) {
          order_confirmation.creating_order = false;
          $rootScope.$broadcast('load_items');
        }
      });
    };

    $scope.send_order_confirmation = function(order_confirmation) {
      $scope.dialog_order_confirmation = order_confirmation;
      $.fancybox($('div#send_order_confirmation'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'yes',
        afterShow: function() {
          $scope.$broadcast('$tinymce:refresh');
        }
      });
    };

    $scope.check_supplier_contacts = function() {
      _.each($scope.offer_request.supplier_contacts, function(contact) {
        contact.checked = $scope.checked_all_supplier_contacts;
      });
    };

    $scope.send_order_confirmation_notification = function() {
      var contacts = _.where($scope.offer_request.supplier_contacts, {
        checked: true
      });
      if (!$scope.doc_details && !$scope.doc_specs) {
        alert('Please select at least one attachment!');
        return false;
      }
      if (contacts.length === 0) {
        alert('Please select at least one supplier contact!');
        return false;
      }
      $scope.sending_order_confirmation_notification = true;
      OfferRequestService.send_order_confirmation_notification($scope.dialog_order_confirmation.id, $scope.doc_details, $scope.doc_specs, $scope.supplier_custom_text, contacts, $scope.sender_name_en, $scope.sender_name_el, $scope.test_send, $scope.test_send_email).success(function(data) {
        if (data.success) {
          $scope.sending_order_confirmation_notification = false;
          $.fancybox.close();
        }
      });
    };

    $scope.view_sent_notifications = function(order_confirmation) {
      $scope.dialog_notifications = order_confirmation.notifications;
      $.fancybox($('div#order_confirmation_notifications'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no'
      });
    };

    $scope.update_order_confirmation_field = function(order_confirmation, field, loader) {
      order_confirmation[loader] = true;
      OfferRequestService.update_order_confirmation_field(order_confirmation.id, field, order_confirmation[field]).success(function(data) {
        if (data.success)
          order_confirmation[loader] = false;
      });
    };

    $scope.set_order_confirmation_items_checked = function(order_confirmation) {
      _.each(order_confirmation.items, function(item) {
        item.checked = order_confirmation.checked_all;
      });
    };

    $scope.order_confirmation_items_checked = function(order_confirmation) {
      return _.findWhere(order_confirmation.items, {
        checked: true
      });
    };

    $scope.delete_order_confirmation = function(order_confirmation) {
      if (confirm('Are you sure you want to delete this OC?')) {
        order_confirmation.deleting_order_confirmation = true;
        OfferRequestService.delete_order_confirmation(order_confirmation.id).success(function(data) {
          if (data.success) {
            order_confirmation.deleting_order_confirmation = false;
            $rootScope.$broadcast('load_items');
          }
        });
      }
    };

    $scope.get_fields = function() {
      return _.filter($scope.fields, function(f) {
        return $scope.item_view === 1 || f.standard !== false;
      });
    };

    $scope.get_request_fields = function() {
      return _.filter($scope.request_fields, function(f) {
        return $scope.item_view === 1 || f.standard !== false;
      });
    };

    /*function price_incoterm_match(request_field) {
      if (!request_field.is_price || !$scope.offer_request.delivery_term_id)
        return true;
      else if (request_field.is_price)
        return request_field.name === $scope.offer_request.delivery_term;
    }*/

    $scope.export_items = function(tab) {
      var items = _.where($scope.tabs[tab].items, {
        checked: true
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.export_items_mode = 'default';
        $scope.selected_items = _.pluck(items, 'id');
      }
    };

    $scope.export_items_for_suppliers = function(tab) {
      var items = _.where($scope.tabs[tab].items, {
        checked: true
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.export_items_mode = 'suppliers';
        $scope.selected_items = _.pluck(items, 'id');
      }
    };

    $scope.update_item_prices = function(tab) {
      var items = _.where($scope.tabs[tab].items, {
        checked: true
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.mass_updating_prices = true;
        OfferRequestItemService.mass_update_prices(window.offer_request.id, _.pluck(items, 'id')).success(function(data) {
          if (data.success) {
            $scope.mass_updating_prices = false;
            $scope.tabs[tab].checked = false;
            $rootScope.$broadcast('load_items');
          }
        });
      }
    };

    $scope.$watch('selected_items', function() {
      $timeout(function() {
        if ($scope.selected_items && $scope.selected_items.length > 0)
          $('form#createXLS').submit();
      }, 300);
    });

    $scope.item_views = [
      {
        id: 0,
        title: 'Standard View'
      },
      {
        id: 1,
        title: 'Full View'
      }
    ];

    $scope.show_connect_order = function(order_confirmation) {
      $scope.connect_order_dialog = {
        order_confirmation: order_confirmation,
        order: null,
        copy_items: false
      };
      $.fancybox($('div#connect_order'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15
      });
    };

    $scope.connect_order = function() {
      if (!$scope.connect_order_dialog.order) {
        alert('Please input a valid order!');
        return false;
      }
      $scope.connecting_order = true;
      OfferRequestService.connect_order($scope.connect_order_dialog.order_confirmation.id, $scope.connect_order_dialog.order, $scope.connect_order_dialog.copy_items).success(function(data) {
        if (data.success) {
          $scope.connecting_order = false;
          $rootScope.$broadcast('load_items');
          $.fancybox.close();
        }
      });
    };

    $scope.update_buyer_preferences = function() {
      $scope.updating_buyer_preferences = true;
      OfferRequestService.update_buyer_preferences($scope.offer_request.id).success(function(data) {
        if (data.success)
          $scope.updating_buyer_preferences = false;
      });
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.status_options = OfferRequestItemService.get_status_options();
      $scope.tinymceOptions = UiService.tinymceOptions();
      $scope.tinymceOptions.height = 100;
      $scope.custom_text = '';
      $scope.test_send = true;
      $scope.test_send_email = 'p.tsolpagas@epsilon-paper.com';
      $scope.recipient_modes = EmailService.get_recipient_modes();
      $scope.sender_names_en = EmailService.get_sender_names_en();
      $scope.sender_names_el = EmailService.get_sender_names_el();
      $scope.sender_name_en = $scope.sender_names_en[0];
      $scope.sender_name_el = $scope.sender_names_el[0];
      $scope.offer_request.supplier_contacts = _.filter($scope.offer_request.supplier_contacts, function(c) {
        return !_.isEmpty(c.email);
      });
      _.each(window.offer_request.supplier_contacts, function(c) {
        c.recipient_mode = 0;
      });
      $scope.doc_details = true;
      $scope.doc_specs = true;
      $scope.item_view = 0;
      $scope.export_buyer_details = true;
    };

    $scope.init();
  }
}

OfferRequestItemTabs.$inject = ['$scope', '$rootScope', '$timeout', 'OfferRequestService', 'OfferRequestItemService', 'EmailService', 'UiService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-request-item-tabs.ctrl.js